import { useEffect, useRef } from "react";
import Aside from "../../components/Aside";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import EmailEditor, { EditorRef, EmailEditorProps } from "react-email-editor";
import Button from "../../components/Button";
import { useLocation, useNavigate } from "react-router-dom";
import Input from "../../components/Input";
import { useForm } from "react-hook-form";
import { EmailTemplateService } from "../../services/emailTemplateService";
import Alert from "../../components/Alert";

export default function EmailBuilderPage() {
  const navigate = useNavigate();
  const emailEditorRef = useRef<EditorRef>(null);
  const { state } = useLocation();
  const template = state?.template;

  const defaultValues = {
    _id: template?._id || "",
    name: template?.name || "",
    html: template?.html || "",
    design: template?.design || {}
  };
  const {
    control,
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    setError,
    formState: { errors, isValid, isSubmitting },
  } = useForm({
    mode: "onChange",
    defaultValues,
  });

  const onReady: EmailEditorProps["onReady"] = (unlayer) => {
    // unlayer.registerCallback("image", async (file: any, done: any) => {
    //   try {
    //     done({ progress: 0 });
    //     const data = new FormData();
    //     data.append('file', file.attachments[0]);
    //     const { url } = await EmailTemplateService.uploadMedia(data);
    //     done({ progress: 100, url });
    //   } catch (error) {
    //     done({ progress: 100, url: '' });
    //   }
    // });
  };

  const submit = async (data: typeof defaultValues) => {
    try {
      const { html, design } = await exportHtml();
      
      data.html = html;
      data.design = design;

      await EmailTemplateService.save(data);
      
      Alert.fire({
        title: 'Plantilla guardada',
        text: `La plantilla se ha guardado correctamente.`
      });

      navigate(`/templates/email`);
    } catch (error) {
      console.error(error);
    }
  };

  const exportHtml = async (): Promise<{ html: string; design: any }> => {
    return new Promise((resolve) => {
      emailEditorRef?.current?.editor?.exportHtml((data) => {
        const { html, design } = data;

        resolve({ html, design });
      });
    });
  };

  useEffect(() => {
    if (template) {
      setTimeout(() => {
        emailEditorRef.current?.editor?.loadDesign(template.design);
      }, 500);
    }
  }, [template]);
  return (
    <>
      <Header>
        <div>
          <h4>Plantillas de correo</h4>
          <p>Administra y crea nuevas plantillas de correo</p>
        </div>

        <div className="ms-auto">
          <button
            type="button"
            className="btn btn-outline-primary btn-sm me-2"
            onClick={() => navigate(`/templates/email`)}
          >
            cancelar
          </button>
          <Button type="submit" className="btn btn-primary btn-sm" isLoading={isSubmitting} onClick={handleSubmit(submit)}>
            Guardar campaña
          </Button>
        </div>
      </Header>

      <Aside />

      <main role="main" className="main">
        <div className="content container px-5">
          <div className="m-b-24">
            <Input
              label="Nombre de plantilla *"
              errors={errors.name}
              {...register("name", { required: true })}
            />
          </div>

          <div className="card-table table">
            <EmailEditor
              ref={emailEditorRef}
              onReady={onReady}
              style={{ height: "calc(100vh - 300px)", width: "100%" }}
              options={{
                projectId: 281605,
                displayMode: "email",
                locale: "es",
                tools: { menu: { enabled: false } }
              }}
            />
          </div>
        </div>
        <Footer />
      </main>
    </>
  );
}
